export enum ExpiredColumnQueryNameEnum {
    tariffId = 'tariffId',
}
